<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="SAMPLE ORDER CREATE" >
          <template slot="actions">

            <vs-button v-can="'create-edit-sample-order'" icon-pack="feather" icon="icon-arrow-left" @click="refreshData" class="mr-4" color="primary" type="border">
              Back to sample orders
            </vs-button>
          </template>

          <div slot="no-body" class="mt-4">
             <div class="vx-row" v-if="show_warning_alerts">
                <div class="vx-col w-full mx-2">
                  <vs-alert :active="customerLeadId && !lead_account_currency" color="danger" class="mb-1">
                    <span>You cannot create sample order/order invoice without setting the currency for this lead on the profile tab. Please add and retry.</span>
                  </vs-alert>
                  <!-- <vs-alert :active="customerLeadId && !is_lead_address_found" color="danger">
                    <span>Lead addresses are required to create an invoice. Please add the addresses and try again.</span>
                  </vs-alert> -->
                </div>
             </div>
            <vs-table id="sample_list" v-can="'view-sample-order'" :hoverFlat="true"
                      :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff" @sort="handleSort"   :sst="true"
                      stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="header">

                <v-select v-on:input="onSelectCustomer('customer')" v-if="is_on_main_page" :clearable="true" name="customer_id" placeholder="Select customer"
                          :append-to-body="true"
                          class="is-label-placeholder px-2 pb-5 mt-4 w-full md:w-1/4 xl:w-1/7 rounded-full"
                          label="company_name" v-model="customerId" :reduce="option => option.id"
                          :options="customers_list" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span v-can:any="['end-user', 'executive-admin']" v-if="is_on_main_page">or</span>
                <v-select v-on:input="onSelectCustomer('lead')" v-if="is_on_main_page" :clearable="true" name="customer_id" placeholder="Select customer lead"
                          :append-to-body="true"
                          class="is-label-placeholder px-2 pb-5 mt-4 w-full md:w-1/4 xl:w-1/7 rounded-full"
                          label="company_name" v-model="customerLeadId" :reduce="option => option.id"
                          :options="marketing_leads" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-can:any="['end-user', 'executive-admin']">
                          <template slot="option" slot-scope="option">
                            {{ option.company_name || option.email }}
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            {{ option.company_name || option.email }}
                          </template>
                </v-select>

                <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                          v-model="filters['search']"
                          class="is-label-placeholder pl-1 pb-5 w-full md:w-1/4 xl:w-1/7 rounded-full mr-8" />

                <vs-button id="place_order" v-can="'create-edit-sample-order'" icon-pack="feather" icon="icon-shopping-cart" @click="onClickPlaceOrder" class="mr-12" color="primary" type="filled">
                  Place order ({{cartItems.length}} Items)
                </vs-button>

              </template>

              <template slot="thead">
                <vs-th width="15%" sort-key="formulation_code">PRODUCT CODE</vs-th>
                <vs-th width="15%" sort-key="name">NAME</vs-th>
                <vs-th width="15%">DESCRIPTION</vs-th>
                <vs-th width="10%">UNIT PRICE (GBP/KG)</vs-th>
                <vs-th width="10%">QUANTITY (GRAMS)</vs-th>
                <vs-th width="10%">NET VALUE (GBP)</vs-th>
                <vs-th width="10%">PRICING TYPE</vs-th>
                <vs-th width="10%" class="" v-can="'create-edit-sample-order'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].formulation_code">
                    {{ data[indextr].formulation_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name}}
                  </vs-td>

                  <vs-td :data="data[indextr].description">
                    {{ data[indextr].description}}
                  </vs-td>

                  <vs-td>
                    <vs-input  type="number" v-model="data[indextr].price" class="w-full"
                              :name="indextr+'price'" />
                  </vs-td>

                  <vs-td>
                    <vs-input  type="text" v-model="data[indextr].quantity" class="w-full"
                              :name="indextr+'quantity'" />
                  </vs-td>

                  <vs-td :data="data[indextr].description">
                    {{ calculateNetValue(data[indextr]) }}
                  </vs-td>

                  <vs-td :data="data[indextr].pricing_type">
                    <vs-button size="small" color="primary" type="border" @click.stop="onClickPricingType(data[indextr], indextr)">{{ data[indextr].pricing_type }}</vs-button>
                  </vs-td>

                  <vs-td v-can="'create-edit-sample-order'">
                    <div class="vx-row">
                      <vx-tooltip class="" text="Add to cart" position="top">
                        <vs-button :disabled="Number(tr.quantity) < 0 || !tr.quantity" :id="'add_button'+''+ indextr" v-if="!checkSampleInCart(data[indextr])"
                                   @click.stop="onClickAddToCart(data[indextr].id, data[indextr].quantity, data[indextr].price, indextr)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus">Add</vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="mr-2" text="Update quantity" position="top">
                        <vs-button :id="'update_button'+''+ indextr" v-if="checkSampleInCart(data[indextr])"
                                   @click.stop="onClickUpdateCart(data[indextr].id, data[indextr].quantity, data[indextr].price, indextr)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-save"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="" :text="`Remove ${data[indextr].formulation_code}`" position="top">
                        <vs-button :id="'remove_button'+''+ indextr" v-if="checkSampleInCart(data[indextr])"
                                   @click.stop="onClickRemoveFromCart(data[indextr].id, indextr)"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>

                    </div>
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <create-customer-sample-order-pop-up ref="createCustomerSampleOrderPopUp"/>
    <calculate-bespoke-prices ref="calculateBespokePrices" @onItemUpdated="onItemUpdated" :account_currency="customer_account_currency"/>
    <!-- <calculate-list-prices ref="calculateListPrices" @onItemUpdated="onItemUpdated" account_currency="GBP"/> -->
    <sample-order-no-check-pop-up @setCustomerSamplePoNo="setCustomerSampleOrderNo" ref="sampleOrderNoCheckPopUp"/>

    <vs-popup title="Sample Order Pricing" :active.sync="active_charge_prompt" :buttons-hidden="true">
      <div class="text-center p-4">
        <p class="mb-6 text-lg">Is this sample order free of charge or chargeable?</p>
        <div class="flex justify-center" style="gap: 1rem;">
          <vs-button color="success" type="filled" @click="onSelectChargeType(false)">Chargeable</vs-button>
          <vs-button color="warning" type="filled" @click="onSelectChargeType(true)">Free of Charge</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import Calculations from '@/mixins/Calculations';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import CreateCustomerSampleOrderPopUp from '@/components/popups/customer/sample-orders/CreateCustomerSampleOrderPopUp'
  import CalculateBespokePrices from '@/components/popups/customer/sample-orders/CalculateBespokePrices.vue';
  import CalculateListPrices from '@/components/popups/customer/sample-orders/CalculateListPrices.vue';
  import SampleOrderNoCheckPopUp from '@/components/popups/customer/sample-orders/SampleOrderNoCheckPopUp.vue';

  const CustomerRepository = RepositoryFactory.get('customer')
  const DropDownRepository = RepositoryFactory.get('drop_down')
  const CrmRepository = RepositoryFactory.get('crm')
  const SettingsRepository = RepositoryFactory.get('settings');
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: null,
        cartItems: [],
        customer_id: null,
        customers_list: [],
        is_free_of_charge:false,
        is_on_main_page: true,
        marketing_leads: [],
        customerLeadId: null,
        default_sample_item_price: '0.00',
        effective_sample_price: '0.00',
        active_charge_prompt: false,
        customer_account_currency: null,
        show_warning_alerts: false,
        lead_account_currency: null,
        is_lead_address_found: false,
        customer_sample_order_no: "",
      }
    },
    props: {
      is_free_of_charge_sample: {
        type: Boolean,
        default: false
      }
    },
    components: {
      'v-select': vSelect,
      CreateCustomerSampleOrderPopUp,
      CalculateBespokePrices,
      CalculateListPrices,
      SampleOrderNoCheckPopUp,
    },
    mixins : [Filter, SuccessMessage, ErrorMessages, Calculations],
    async mounted () {
      await this.fetchDefaultPrice()
      this.customerId = this.$route.params.id
      if(this.customerId){
        this.is_free_of_charge = this.is_free_of_charge_sample
      }
      this.is_on_main_page = !this.$route.params.id
      if(this.is_on_main_page) {
        await this.getCustomers()
        if(this.$canAny(['end-user', 'executive-admin'])) {
          await this.fetchCustomerLeads()
        }
      }
      if(!!this.$route.query.create) {
        this.customerLeadId = Number(this.$route.query.create)
        await this.onSelectCustomer('lead')
      }
      await this.getSageDepartments()
    },
    methods: {
      async refreshData () {
        await this.fetchSampleList()
        this.$emit('back')
      },
      async onlyRefreshData() {
        await this.fetchSampleList()
      },
      async fetchSampleList() {
        if(this.customerId || this.customerLeadId) {
          try {
            await this.$vs.loading()
            await this.getItemsInItemsCart()
            const customerId = this.customerLeadId !== null ? null : this.customerId;
            const {data} = await CustomerRepository.getSampleList(customerId, this.page, this.filterQuery, 20, this.sort)
            this.staff =  data.data.map((x) => {
              x.price_tiers = x.price;
              let find = this.cartItems.find((n) => n.formulation_id === x.id)
              if(find) {
                x.quantity = find.quantity
                x.price = find.price
              } else {
                x.quantity = null
                x.price = this.effective_sample_price
              }
              return x;
            })
            this.meta = data.meta
          } catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        }
      },
       async getSageDepartments(){
          this.$vs.loading()
          const {data} = await SageSettingsRepository.getListOfSageDepartments('','','',0)
          this.sage_departments =  data.data
          this.$vs.loading.close()
        },
      onClickPricingType(data, index){
        if(data.pricing_type === "Bespoke" || data.pricing_type === "Contract") {
          this.$refs.calculateBespokePrices.openPopup(data, index, false, this.customerId)
        }else if(data.pricing_type === "List") {
          this.$refs.calculateListPrices.openPopup(data, index, this.customerId)
        }
      },
      onItemUpdated(data, index){
        this.staff[index].price = Number(data.price)
        this.staff[index].quantity = data.quantity
      },
      calculateNetValue(item) {
        const quantityInKg = Number(item.quantity) / 1000;
        const unitPrice = Number(this.$options.filters.format_price(item.price, 1));
        return (quantityInKg * unitPrice).toFixed(2);
      },
      async onClickAddToCart(id, quantity, price, indextr) {
        await this.$vs.loading({
          container: `#add_button${indextr}`,
          scale: 0.45
        })
        try {
          const cartPayload = {
            customer_id: this.customerId,
            customer_lead_id: this.customerLeadId,
            formulation_id: id,
            quantity: quantity,
            price: price,
          }
          if (this.customerId) delete cartPayload.customer_lead_id;
          else if (this.customerLeadId) delete cartPayload.customer_id;
          await CustomerRepository.addFormulationsToCart(cartPayload)
          await this.getItemsInItemsCart()
          this.showSuccessMessage(' Added to the Cart')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#add_button${indextr} > .con-vs-loading`)
      },
      async onClickRemoveFromCart(id, indextr) {
        await this.$vs.loading({
          container: `#remove_button${indextr}`,
          scale: 0.45
        })
        try {
          const search = this.cartItems.find((n) => n.formulation_id === id )
          await CustomerRepository.removeFormulationsFromCart(search.id)
          await this.fetchSampleList()
          this.showSuccessMessage('Removed from cart')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#remove_button${indextr} > .con-vs-loading`)
      },

      async onClickUpdateCart(id, quantity, price, indextr) {
        await this.$vs.loading({
          container: `#update_button${indextr}`,
          scale: 0.45
        })
        try {
          const search = this.cartItems.find((n) => n.formulation_id === id )
          await CustomerRepository.updateFormulationSampleCart(search.id, { quantity: quantity, price: price })
          await this.getItemsInItemsCart()
          this.showSuccessMessage('Cart updated')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#update_button${indextr} > .con-vs-loading`)
      },

      async getItemsInItemsCart() {
        await this.$vs.loading({
          container: '#place_order',
          scale: 0.45
        })
        try {
          const queries = this.customerId ? `customer_id=${this.customerId}` : (this.customerLeadId ? `customer_lead_id=${this.customerLeadId}` : '');
          const { data } = (await CustomerRepository.getItemsInItemsCart(queries)).data;
          this.cartItems = data
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#place_order > .con-vs-loading')
      },
      async getCustomers() {
        await this.$vs.loading()
        const {data} = await DropDownRepository.getCustomersList()
        this.customers_list = data.data
        await this.$vs.loading.close()
      },
      async fetchCustomerLeads() {
        await this.$vs.loading()
        const { data } = await DropDownRepository.getCustomerLeadList()
        this.marketing_leads = data.data
        await this.$vs.loading.close()
      },
      async onClickPlaceOrder() {
        if(this.isDisabledButton) {
            this.$vs.dialog({
              color: 'danger',
              title: `Warning`,
              text: this.cartItems.length === 0 ? 'Please add items to the cart' : 'Please select the currency for the lead',
              acceptText: 'Close'
            })
          return 
        }
        await this.$refs.createCustomerSampleOrderPopUp.openPopup(this.customerId, this.customerLeadId, this.is_free_of_charge, this.customer_sample_order_no)
      },

      filterQueryUpdate (){
        this.fetchSampleList()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchSampleList()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchSampleList()
        }
      },
      projectBriefColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return 'primary';
          case 3:
            return '#f05945';
          case 4:
            return '#f58634';
          case 5:
            return '#206a5d';
        }
      },
      onClickFormula(id) {
        this.$router.push({path: `/pages/formulations/${id}`})
      },
      onClickStatusChangeConfirm(id, status) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onChangeSampleOrderStatus,
          parameters: [id, status]
        })
      },
      async onChangeSampleOrderStatus(params){
        this.$vs.loading()
        try {
          await CustomerRepository.statusChangeCustomerSampleOrders(params[0], params[1])
          this.showSuccessMessage('Status change successfully!')
          await this.fetchSampleList()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      checkSampleInCart: function (object) {
        const arr = this.cartItems.filter((n) => n.formulation_id === object.id)
        return arr.length > 0
      },
      getCurrencyLabel(){
        if (this.customerLeadId && this.lead_account_currency) {
            return this.lead_account_currency || 'N/A';
        } else if (this.customerId && this.customer_account_currency) {
            return this.customer_account_currency || 'N/A';
        }
        return 'N/A';
      },
      async onSelectCustomer(type) {
        this.show_warning_alerts = false
        if ( type === 'customer' ) {
          this.customerLeadId = null
          this.lead_account_currency = null
          this.is_lead_address_found = false

          this.customer_account_currency = this.customers_list.find((c) => c.id === this.customerId).account_currency

        }
        if(type === 'lead') {
          this.customerId = null
          if(!this.customerLeadId) {
            this.show_warning_alerts = false
            return;
          }
          try {
            await this.$vs.loading()
            const leadData = (await CrmRepository.getMerketingLeadDetails(this.customerLeadId)).data.data
            const leadSiteData = (await CrmRepository.getLeadSiteList(this.customerLeadId)).data.data

            this.lead_account_currency = leadData.account_currency || null;
            this.is_lead_address_found = leadSiteData.length > 0;
            this.show_warning_alerts = true
          } catch (e) {
            this.show_warning_alerts = false
          } finally {
            await this.$vs.loading.close()
          }
        }
        if(this.customerLeadId && !this.lead_account_currency) {
          document.getElementById("place_order").disabled = true
        }

        this.active_charge_prompt = true
        this.$router.replace({ query: null })
      },
      async onSelectChargeType(isFreeOfCharge) {
        this.is_free_of_charge = isFreeOfCharge
        this.effective_sample_price = isFreeOfCharge ? '0' : this.default_sample_item_price
        this.active_charge_prompt = false
        await this.fetchSampleList()
        if(!this.is_free_of_charge){
        this.openSampleOrderNoCheck()
        }
      },
      openSampleOrderNoCheck(){
        if(this.customerId){
          this.$refs.sampleOrderNoCheckPopUp.openPopup(this.customerId, '')
        }
        else {
          this.$refs.sampleOrderNoCheckPopUp.openPopup('', this.customerLeadId)
        }
      },
      setCustomerSampleOrderNo(order_no) {
        this.customer_sample_order_no = order_no
      },
      async fetchDefaultPrice() {
        try {
          const settings = (await SettingsRepository.getTheItem('default_sample_item_price')).data.data
          this.default_sample_item_price = settings.default_sample_item_price
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },

    },
    watch : {
      page(){
        this.fetchSampleList()
      }
    },
    computed: {
      isDisabledButton: function() {
        return this.cartItems.length === 0 || (this.customerLeadId && !this.lead_account_currency)
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
  table td {
    vertical-align: top;
    min-width: 140px;
    padding-bottom: .8rem;
    word-break: break-all;
    }

</style>
